fx.ns("desktop.common.screens", class Splash extends desktop.common.screens.BaseSplash{
    
	constructor()
	{
		super();

		this.showEffect = "hslideout";
		this.hideEffect = "hslidein";

		this.destroyOnSwitch = true;
	}

	onReady()
	{
		super.onReady();

        if (fx.get("mode") == "creating" || fx.get("mode") == "creating-ia")
            this.data.create();
        else
            this.data.load();

		if (this.data.iaEnabled && fx.get("mode") ==  "creating-ia")
		{
			this.title = fx.text("C'est parti !");
		}
        else
        if (fx.get("mode") ==  "creating")
        {
            this.title = fx.text("C'est parti !");
        }
		else
		{
			//if (this.data.preview)
            if (fx.get("previewMode"))
				this.title = fx.text("Je vérifie votre album..");
			else
			{
				this.title = fx.text("Je prépare votre album");
				this.subtitle = fx.text("Ça va être génial !");
			}
		}
	}

	onDataEvent(event)
	{
        if (event.type == "creation-loaded")
        {
            if (fx.get("previewMode"))
            {
                if (this.data.report().failed)
                    this.data.event("next-step", null, this.getDelay(1500));
                else
                    this.data.event("navigate-order");
            }
            else
                this.data.event("next-step", null, this.getDelay(500));
        }
			
		if (event.type == "creation-created")
			this.data.event("next-step", null, this.getDelay(1500));
	}



});

	